// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PatientPage-Notes-__notes__container--2yvLc","notesList":"src-components-PatientPage-Notes-__notes__notesList--3Xze6","addButton":"src-components-PatientPage-Notes-__notes__addButton--2j0kf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/Notes/notes.css
// module id = 1987
// module chunks = 0